import { render, staticRenderFns } from "./place-unavailable.vue?vue&type=template&id=c8d0f968&scoped=true"
import script from "./place-unavailable.vue?vue&type=script&lang=js"
export * from "./place-unavailable.vue?vue&type=script&lang=js"
import style0 from "./place-unavailable.vue?vue&type=style&index=0&id=c8d0f968&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d0f968",
  null
  
)

export default component.exports